var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5V6.5C10.5 5.96957 10.7107 5.46086 11.0858 5.08579C11.4609 4.71071 11.9696 4.5 12.5 4.5H19.5C20.0304 4.5 20.5391 4.71071 20.9142 5.08579C21.2893 5.46086 21.5 5.96957 21.5 6.5V18.5C21.5 19.0304 21.2893 19.5391 20.9142 19.9142C20.5391 20.2893 20.0304 20.5 19.5 20.5H12.5C11.9696 20.5 11.4609 20.2893 11.0858 19.9142C10.7107 19.5391 10.5 19.0304 10.5 18.5V16.5M15.5 12.5H3.5M3.5 12.5L6.5 9.5M3.5 12.5L6.5 15.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.3e77e941e01c09207a450d1c69f7d0ca.svg";
export { ForwardRef as ReactComponent };